import PageTitleComponent from "../../components/PageTitle";
import UserProfilesList from "../../components/Users";

export default function UsersScreen(){
return <div>
    <PageTitleComponent title="Users" />
    <UserProfilesList/>
</div>
}